import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DeleteSweepOutlinedIcon from '@mui/icons-material/DeleteSweepOutlined';

const ArnoldDrmMenus = [
    {
        label: 'sidebar.menu.drm',
        type: "section",
        children: [
            {
                uri: "/drm/audit-result",
                label: 'sidebar.menuItem.audit-result',
                type: "nav-item",
                icon: <DescriptionOutlinedIcon sx={{fontSize: 20}}/>
            },
            {
                uri: "/drm/archive",
                label: 'sidebar.menuItem.archive',
                type: "nav-item",
                icon: <DeleteSweepOutlinedIcon sx={{fontSize: 20}}/>
            },
        ]
    },
   
];

export default ArnoldDrmMenus;